import { sleep } from '@helpers/threads'
/**
 * `useWindow` hook will return window context and all customized helper functions.
 */
export const useWindow = () => {
  const windowContext = typeof window === 'undefined' ? {} : window

  /**
   * Pushes data to dataLayer array on window context
   * @param {object} data
   * @returns {void}
   */
  const pushToDataLayer = ({ event, data }) => {
    const { dataLayer } = windowContext
    dataLayer?.push({ event, ...data })
  }

  /**
   * Checks if property is initialized on window context
   * @param {string} property
   * @param {number} attempts
   * @param {number} miliseconds
   * @returns {Promise<bool>}
   */
  const checkProperty = async (property, attempts = 30, miliseconds = 1000) => {
    if (typeof windowContext?.[property] !== 'undefined') {
      return true
    }
    if (attempts > 0) {
      await sleep(miliseconds)
      const propertyExists = await checkProperty(property, attempts - 1)
      if (propertyExists) {
        return true
      }
    }
    throw new Error(`Property ${property} not found.`)
  }

  return { windowContext, pushToDataLayer, checkProperty }
}

export default useWindow
